import React from "react";
import "./Experience.css";

const Experience = () => {
  return (
    <div>


<div className="experience">
        <div className="info-exp">
          <div className="infor-heading">
            <h2 className="job-title">  Info Services  - Trainee Software Engineer  </h2>

            <p className="duration">June 2024 - present</p>
          </div>

          <p className="job-desc">
          Contributed to the design and development of applications, leveraging microservices architecture with Spring Boot. Collaborated
closely with senior architects to understand and refine project components.Worked effectively with various teams, including internal, vertical, cross-functional, and external, to gather requirements and
build the product. Demonstrated strong communication and collaboration abilities.
          </p>
        </div>
      </div>


      <div className="experience">
        <div className="all-experience"></div>
        <div className="info-exp">
          <div className="infor-heading">
            <h2 className="job-title">GenieHub Network Pvt Ltd - Backend Developer Intern</h2>

            <p className="duration">Jan 2024 - Present</p>
          </div>
          <p className="job-desc">
            Leveraged Object-Oriented Programming for scalable and robust
            software solutions. Collaborated with a cross-functional team to
            deliver high-quality products and services. Specialized as a Backend
            Engineer using Java, Spring Boot, and MongoDB in the tech stack.
          </p>
        </div>
      </div>

      <div className="experience">
        <div className="info-exp">
          <div className="infor-heading">
            <h2 className="job-title">Truco XP - Software Developer Intern </h2>

            <p className="duration">April 2023 - Nov 2023</p>
          </div>

          <p className="job-desc">
            Designed, developed, and optimized systems to ensure data integrity
            and efficient data retrieval. Collaborated closely with other
            developers to seamlessly integrate front-end and back-end
            components.Stayed updated on industry trends and best practices in
            web development, contributing to the team’s success.
          </p>
        </div>
      </div>

      <div className="experience">
        <div className="info-exp">
          <div className="infor-heading">
            <h2 className="job-title">Exposys Data Labs - Web Developer </h2>

            <p className="duration">Jan 2023 - Feb 2023</p>
          </div>

          <p className="job-desc">
            Developed modern, responsive web applications using React.js
            Implemented new features, debugged code, and enhanced user
            interfaces for high-quality, user-friendly web applications. Gained
            valuable experience with frontend development tools, libraries, and
            Git for version control, emphasizing a strong understanding of
            quality web application delivery
          </p>
        </div>
      </div>
    </div>
  );
};

export default Experience;
